const getSavedLanguage = (): string => {
 try {
  const user = localStorage.getItem('user')
  if (!user) return 'en'

  const parsedUser = JSON.parse(user)
  return parsedUser?.selectedLanguage || 'en'
 } catch {
  return 'en'
 }
}

export {getSavedLanguage}
